<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 mt-20"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">ADD PRODUCT</h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <!-- <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
      <b-form role="form" @submit.prevent="handleSubmit(handleSubmitForm)"> -->
    <div class="p-4 mb-8">
      <!-- <h2 class="mb-4 font-semibold text-base">Product Form</h2> -->

      <!-- <ProductForm /> -->

      <div class="mb-4">
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <img v-if="image" :src="image" ref="cover" />
        <div
          class="text-center text-red cursor-pointer"
          v-if="image"
          @click="handleRemove"
        >
          Remove image
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      </div>
      <!-- <validation-provider rules="required" v-slot="{ errors }">
        <input v-model="name" name="myinput" type="text" />
        <span>{{ errors[0] }}</span> -->

      <div class="mb-4">
        <!-- <ValidationProvider
              ref="formValidation"
              name="productName"
              rules="required|email"
              v-slot="{ errors }"
            > -->
        <p class="font-semibold text-sm mb-2">Product Name</p>
        <b-input
          v-model="name"
          type="text"
          :name="'productName'"
          placeholder="Enter Product Name..."
          @blur="handleName()"
        >
        </b-input>
        <span v-if="nameErr" class="small text-danger">{{
          "Field is required"
        }}</span>

        <!-- <span v-if="errors[0]" class="text-danger fsize12">{{
                errors[0]
              }}</span>
            </ValidationProvider> -->
      </div>

      <div class="mb-4">
        <!-- <b-input-group prepend="Write Description" class="input-group-merge"> -->
        <!-- <validation-provider
          ref="formValidation"
          name="description"
          rules="required"
          v-slot="{ errors }"
        > -->
        <p class="font-semibold text-sm mb-2">Product description</p>
        <b-form-textarea
          placeholder="Write Description..."
          v-model="description"
          :name="'description'"
          required
        ></b-form-textarea>
        <span v-if="descErr" class="small text-danger">{{
          "Field is required"
        }}</span>
        <!-- <span v-if="errors[0]" class="text-danger fsize12"
            >{{ errors[0] }}
          </span>
        </validation-provider> -->
        <!-- </b-input-group> -->
      </div>

      <div class="mb-4">
        <!-- <validation-provider
          ref="formValidation"
          name="brand"
          rules=""
          v-slot="{ errors }"
        > -->
        <p class="font-semibold text-sm mb-2">Brand</p>
        <!-- <b-input
          v-model="brand"
          placeholder="Enter Brand ..."
          :name="'brand'"
          required
        /> -->
        <multiselect
          name="brand"
          v-model="brand"
          :options="brandData"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Memberships"
          track-by="name"
          label="name"
          :preselect-first="false"
        >
        </multiselect>
        <span v-if="brandErr" class="small text-danger">{{
          "Field is required"
        }}</span>
        <!-- <span v-if="errors[0]" class="text-danger fsize12"
            >{{ errors[0] }}
          </span>
        </validation-provider> -->
      </div>

      <!-- <div class="mb-4">
        <p class="font-semibold text-sm mb-2">URL</p>
        <b-input
          v-model="url"
          placeholder="Enter URL ..."
          type="url"
          :name="'url'"
          required
        />
        <span v-if="urlErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div> -->
      <div class="mb-2">
        <b-form-checkbox id="checkbox-3" v-model="isURL">
          <p>
            <strong> <p class="col-blk">Affiliate this product</p></strong>
          </p>
        </b-form-checkbox>
      </div>
      <template v-if="isURL">
        <div class="mb-2">
          <p class="font-semibold text-sm mb-2">URL</p>
          <b-form-input
            class="mb-3"
            alternative
            name="URL"
            placeholder="Enter product URL"
            v-model="url"
          >
            <span v-if="urlErr" class="small text-danger">{{
              "Field is required"
            }}</span>
            <!-- <p>
              <strong> <p class="col-blk">Add URL</p></strong>
            </p> -->
          </b-form-input>
        </div>
      </template>
      <template v-if="!isURL">
        <div class="mb-4">
          <p class="font-semibold text-sm mb-2">Stock Units</p>
          <b-input
            v-model="sku"
            placeholder="Enter Stock Units..."
            @change="handleSKU"
          />
        </div>
      </template>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Coupon code</p>
        <b-input
          v-model="couponCode"
          placeholder="Enter Coupon code..."
          required
        />
        <span v-if="ccErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Price</p>
        <b-input
          v-model="price"
          placeholder="Enter Price ..."
          type="number"
          @change="handlePrice"
          required
        />
        <span v-if="priceErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>

      <!-- <div class="mb-4">
          <p class="font-semibold text-sm mb-2">Tags</p>
          <base-input class="div-mb-0">
            <select class="form-control ">
              <option disabled="">Select</option>
              <option>Summer</option>
              <option>Winter</option>
            </select>
          </base-input>
        </div> -->

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Discount %</p>
        <b-input
          v-model="discount"
          placeholder="Enter Discount"
          type="number"
          @input="handleDiscount"
        />
        <span v-if="discountErr" class="small text-danger">{{ msg.disc }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Membership Discounts</p>
        <template v-for="(item, index) in get_all_membership">
          <label>{{ item.name }}</label>
          <b-input
            v-model="memberDisc[item.name]"
            placeholder="Enter Discount"
            type="number"
          />
        </template>
      </div>
    </div>
    <!-- @click.prevent="onSubmit" -->
    <footer class="footer-fix fixed bottom-0 w-1/4">
      <base-button
        @click.prevent="onSubmit"
        block
        type="primary"
        native-type="submit"
        class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
    <!-- </b-form>
    </ValidationObserver> -->
  </side-bar>
</template>

<script>
// import "../../../scss/Index.scss";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import FileUploader from "./FileUploader.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      showcategory: false,
      showproductform: false,
      isURL: false,
      sku: 0,
      name: "",
      description: "",
      url: "",
      brand: "",
      couponCode: "",
      price: 0,
      discount: 0,
      coverImage: null,
      image: null,
      productId: "",
      imageErr: false,
      nameErr: false,
      descErr: false,
      urlErr: false,
      brandErr: false,
      ccErr: false,
      discountErr: false,
      priceErr: false,
      msg: {
        image: "",
        disc: "",
      },
      memberDisc: {},
    };
  },
  components: {
    FileUploader,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },

    ...mapState("affiliate", {
      brandData: "brandData",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  methods: {
    handleDiscount(value) {
      // this.discount = value;
      const newVal = Number(value.toString());
      this.discount = Math.abs(newVal);
      // if (value < 0) {
      //   this.discount = 0;
      // }
    },
    handlePrice(value) {
      const newVal = Number(value.toString());
      this.price = Math.abs(newVal);
      //if (value <= 0) {
      //  this.price = 0;
      //}
    },
    handleSKU(value) {
      const newVal = Number(value.toString());
      this.sku = Math.abs(newVal);
      //if (value <= 0) {
      //  this.sku = 0;
      //}
    },
    handleSubmitForm() {
      this.name = this.name.trim();
      this.description = this.description.trim();
      if (this.isURL) this.url = this.url.trim();
      // this.url = this.url.trim();
      // this.brand = this.brand.trim();
      this.couponCode = this.couponCode.trim();
      // this.$refs.validationProvider.forEach((ref) => {
      //   ref.validate().then((success) => {
      //     if (success) {
      //       this.onSubmit();
      //       console.log("Form is valid. Perform submit action.");
      //     } else {
      //       console.log("Form validation failed.");
      //     }
      //   });
      // });
      // this.$validator.validateAll().then((success) => {
      this.$refs.formValidation.validate().then((success) => {
        if (success) {
          // this.onSubmit();
          // console.log("Form is valid. Perform submit action.");
        } else {
          // console.log("Form validation failed.");
        }
      });
    },
    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z ]*$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async onSubmit() {
      let flag = false;
      let keyName = "";
      Object.keys(this.memberDisc).forEach((keys) => {
        if (
          (this.memberDisc[keys] !== null && this.memberDisc[keys] < 0) ||
          this.memberDisc[keys] > 100
        ) {
          flag = true;
          keyName = keys;
        }
      });
      if (flag) {
        this.$swal({
          text: `Enter valid Membership Discounts for ${keyName}`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      // if (this.coverImage === null) {
      //   this.$swal({
      //     text: "Please Add Image",
      //     icon: "error",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      this.nameErr = false;
      this.descErr = false;
      this.urlErr = false;
      this.brandErr = false;
      this.ccErr = false;
      this.priceErr = false;
      this.discountErr = false;
      this.name = this.name.trim();
      this.description = this.description.trim();
      if (this.isURL) this.url = this.url.trim();
      // this.brand = this.brand.trim();
      this.couponCode = this.couponCode.trim();
      // if (
      //   this.name === "" ||
      //   this.description === "" ||
      //   this.profession === "" ||
      //   this.relate === ""
      // ) {
      //   await this.$swal({
      //     // text: "please add title, description, date and Time",
      //     text: `Please enter all the required details!`,
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      let discountPrice = this.price - (this.price * this.discount) / 100;

      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("description", this.description);
      if (this.isURL === true) {
        payload.append("url", this.url);
        payload.append("isURL", this.isURL);
      } else {
        payload.append("sku", this.sku);
      }
      // payload.append("brand", this.brand);
      if (this.couponCode) payload.append("couponCode", this.couponCode);
      payload.append("price", this.price);
      payload.append("discount", this.discount);
      payload.append("discountPrice", discountPrice);
      if (this.coverImage) payload.append("productImage", this.coverImage);
      if (this.brand) payload.append("brand", JSON.stringify(this.brand));
      payload.append("membershipDisc", JSON.stringify(this.memberDisc));

      let loader;
      try {
        if (this.isURL) {
          if (this.url.trim() == "") {
            await this.$swal({
              text: "URL is required!",
              icon: "warning",
              timer: 1000,
              showConfirmButton: false,
              showCancelButton: false,
            });
            return;
          }
        } else {
          if (this.sku == "") {
            await this.$swal({
              text: "Stock units are required!",
              icon: "warning",
              timer: 1000,
              showConfirmButton: false,
              showCancelButton: false,
            });
            return;
          }
        }
        // console.log(payload);
        loader = this.$loading();
        if (this.name == "") {
          this.nameErr = true;
        } else if (this.description == "") {
          this.descErr = true;
        } else if (this.brand == "") {
          this.brandErr = true;
        } else if (this.couponCode == "") {
          this.ccErr = true;
        } else if (this.price == "") {
          this.priceErr = true;
        }
        //  else if (this.discount == "") {
        //  this.discountErr = true;
        //  this.msg.disc = "Field is required";
        //  }
        else if (this.discount > 100 || this.discount < 0) {
          this.discountErr = true;
          this.msg.disc = "Enter a valid discount value";
        } else {
          const createProduct = await this.$store.dispatch(
            "affiliate/createProduct",
            payload
          );

          if (createProduct.code === 200) {
            // console.log(createProduct);
            this.getAllProduct();
            loader.close();
            this.closeSideBar();
            await this.$swal({
              title: "Success!",
              text: "Your product has been successfully created!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });

            this.name = "";
            this.description = "";
            this.url = "";
            this.brand = "";
            this.price = 0;
            this.discount = 0;
            this.coverImage = null;
            this.image = null;
          }
        }
        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    getAllProduct() {
      this.$emit("getAllProduct");
    },
    closeSideBar() {
      this.isSidebarActiveLocal = false;
    },
  },
  async mounted() {
    await this.get_all_membership.forEach((element, index) => {
      this.memberDisc[element.name] = null;
      this.discErr[element.name] = false;
    });
  },
};
</script>
